import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { getAuth, GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import { PATH_AFTER_LOGIN } from '../../config-global';
import { paths } from '../../routes/paths';
import Auth from '../../services/auth';

const googleSignup = async (response, router, setErrorMsg, login, setSeverity) => {
  // const googleCredential = response.credential;
  // const auth = getAuth();
  // try {
  //   const firebaseCredential = GoogleAuthProvider.credential(googleCredential);
  //   const decoded = jwtDecode(firebaseCredential.idToken);
  //   const { email } = decoded;
  //   const userExists = await Auth.getUser({ email });
  //   const user = {
  //     email: decoded.email,
  //     social: true,
  //     credential: googleCredential,
  //     picture: decoded.picture || null,
  //   };

  //   if (userExists.status === 202) {
  //     sessionStorage.setItem('data', JSON.stringify(user));
  //     router.push(paths.clients.validation);
  //   } else {
  //     const signinResponse = await signInWithCredential(auth, firebaseCredential);
  //     // const responseUser = signinResponse.user;

  //     const { accessToken } = signinResponse.user;
  //     await login(accessToken);
  //     router.push(PATH_AFTER_LOGIN);
  //   }
  // } catch (error) {
  //   // const errorCode = error.code;
  //   // const errorMessage = error.message;
  //   if (error.request?.status === 403) {
  //     setErrorMsg(error.response.data.message);
  //     return;
  //   }
  //   setErrorMsg('Ocurrio un error inesperado, por favor intentelo de nuevo.');
  //   if (setSeverity) {
  //     setSeverity('error');
  //   }
  // }
};

export default googleSignup;
